/* jshint ignore:start */
import Component from 'metal-component';
import Soy from 'metal-soy';

var templates;
goog.loadModule(function(exports) {
var soy = goog.require('soy');
var soydata = goog.require('soydata');
// This file was automatically generated from SingleSelectedOption.soy.
// Please don't edit this file by hand.

/**
 * @fileoverview Templates in namespace SingleSelectedOption.
 * @public
 */

goog.module('SingleSelectedOption.incrementaldom');

goog.require('goog.soy.data.SanitizedContent');
var incrementalDom = goog.require('incrementaldom');
goog.require('soy.asserts');
var soyIdom = goog.require('soy.idom');


/**
 * @param {{
 *  label: (!goog.soy.data.SanitizedContent|function()|string)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function $render(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!goog.soy.data.SanitizedContent|function()|string} */
  var label = soy.asserts.assertType(goog.isFunction(opt_data.label) || (goog.isString(opt_data.label) || opt_data.label instanceof goog.soy.data.SanitizedContent), 'label', opt_data.label, '!goog.soy.data.SanitizedContent|function()|string');
  incrementalDom.elementOpenStart('div');
      incrementalDom.attr('class', 'option-selected');
  incrementalDom.elementOpenEnd();
    soyIdom.print(label);
  incrementalDom.elementClose('div');
}
exports.render = $render;
/**
 * @typedef {{
 *  label: (!goog.soy.data.SanitizedContent|function()|string)
 * }}
 */
$render.Params;
if (goog.DEBUG) {
  $render.soyTemplateName = 'SingleSelectedOption.render';
}

exports.render.params = ["label"];
exports.render.types = {"label":"string|html"};
templates = exports;
return exports;

});

class SingleSelectedOption extends Component {}
Soy.register(SingleSelectedOption, templates);
export { SingleSelectedOption, templates };
export default templates;
/* jshint ignore:end */
